import {
  doc,
  DocumentData,
  FirestoreDataConverter,
  getDoc,
  QueryDocumentSnapshot,
  SnapshotOptions,
  WithFieldValue,
} from "firebase/firestore";

import { Uid } from "@/types";

import { db } from "../firebase/clientApp";

export type FetchDocProps<T> = {
  path: string;
  converter: FirestoreDataConverter<T>;
};

export const createDocumentConverter: <
  AppModelType extends DocumentData,
>() => FirestoreDataConverter<AppModelType> = <
  AppModelType extends DocumentData,
>() => ({
  toFirestore(model: WithFieldValue<AppModelType>): DocumentData {
    const rest = { ...(model as Record<string, unknown>) };
    delete rest.uid;
    return rest;
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions,
  ): AppModelType & { uid: Uid } {
    const data = snapshot.data(options)! as AppModelType;
    return {
      ...data,
      uid: snapshot.id,
    };
  },
});

export const fetchDocSnapshot = async <T>({
  path,
  converter,
}: FetchDocProps<T>) => {
  const docRef = doc(db, path).withConverter(converter);
  return getDoc(docRef);
};

export const fetchDoc = async <T>(props: FetchDocProps<T>) => {
  const docSnapshot = await fetchDocSnapshot(props);
  if (!docSnapshot.exists()) {
    throw new Error(`Document not found: ${props.path}`);
  }
  return docSnapshot.data();
};
